<span class="icon"><i class="material-icons">search</i></span>
<input #filterInput type="text" [placeholder]="placeholder ? placeholder : translate.instant('SEARCHBAR.PLACEHOLDER')" class="search-input"
       (focus)="showClear=true" (blur)="showClear=false"
       (input)="search.next(filterInput.value)"/>
<i class="material-icons clear cursor" [class.clear-active]="showClear"
   (click)="filterInput.value = ''; search.next('')">close</i>
